var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"page-container",attrs:{"fluid":""}},[_c('StandardCheckout',{attrs:{"routeName":_vm.routeName,"combos":_vm.combos,"discount":_vm.discount,"variant":_vm.variant}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }